(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('sidebar', Sidebar)

    /** @ngInject */
    function Sidebar($rootScope, $window, $timeout, $state, AuthenticationService, HelperService, PATHS, LOCAL_STORAGE_ITEMS, DATA_EVENTS) {
        function SidebarController($scope) {
            const vm = this;

            vm.getClusterPerformanceCard = () => {
                const clusterPerformance = vm.loggedUserData.ClusterPerformance;

                if (clusterPerformance.Id == 1)
                    return `/app/dist/images/cluster-cards/bronze.png`;
                else if (clusterPerformance.Id == 2)
                    return `/app/dist/images/cluster-cards/silver.png`;
                else if (clusterPerformance.Id == 3)
                    return `/app/dist/images/cluster-cards/gold.png`;
                else if (clusterPerformance.Id == 4)
                    return `/app/dist/images/cluster-cards/diamond.png`;
            }

            vm.toggleMenuOpen = () => {
                vm.menuOpen = !vm.menuOpen;

                $rootScope.menuOpen = vm.menuOpen;

                localStorage.setItem(LOCAL_STORAGE_ITEMS.MENU, vm.menuOpen);
            }

            vm.handleSubmodule = module => {
                if (!module.ParentModuleId) {
                    if (!module.IsOpen) {
                        vm.modules.forEach(mod => {
                            mod.IsOpen = false;
                        });

                        if (module.Module1.length)
                            module.IsOpen = true;
                    } else {
                        module.IsOpen = false;
                    }
                }
            }

            vm.getState = module => {
                if (module.Module1 && module.Module1.length)
                    return 'null';

                let state = stateOf(module);

                return state ? state.name : 'app.home';
            }

            vm.isActiveMenu = module => {
                if (module.ParentModuleId)
                    return module.Url == $state.current.url;

                return module.Id == $state.current.moduleId;
            }

            vm.getPersonImage = () => {
                let personMainImage = vm.loggedUserData.Person_Image.find(image => (image.Main));

                if (personMainImage)
                    return HelperService.imageResizePath('person', vm.loggedUserData.Id, personMainImage.Url, 150, 150);

                return '/api/images/res/100/100/placeholder.jpg';
            }

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                vm.modules = [];

                init();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
            })

            init();

            // Url vazia nao e' rota: o item "Boletos" do legado tem Url '' e so' serve de cabecalho de submenu, e o state
            // abstrato `app` tambem tem url '' -- sem esta linha ele casaria, e navegar para state abstrato estoura.
            function stateOf(module) {
                return module.Url ? $state.get().find(state => (state.url == module.Url)) : undefined;
            }

            /**
             * Item de menu que nao tem rota neste front nao entra no menu.
             *
             * O item vem do banco (tabela `Module`) e a rota vem daqui, do front. Quando os dois divergem, `getState` nao
             * acha o state e devolve `app.home`: o clique joga o usuario na raiz, sem dizer por que. Foi o que a Central da
             * Lavpop fazia com "Equipamentos" em 30/09/2026 -- a carga dos legados mesclava os dois menus e entregava a
             * uniao as duas redes.
             *
             * A causa no dado foi resolvida: `Module` ganhou marca em 01/10/2026 e cada rede carrega o menu dela. Esta
             * guarda e' a outra metade, e e' a que sobrevive a divergencia NOVA -- item criado no banco antes de o front
             * ter a tela, ou tela renomeada sem atualizar o banco. Em vez de levar para o lugar errado, o item nao aparece,
             * e o console diz qual e por que, para a divergencia ser corrigida em vez de ficar invisivel.
             *
             * Pai e' mantido se tiver filho com rota (ele vira so' cabecalho de submenu, `getState` => 'null') ou se tiver
             * rota propria. A copia e' rasa de proposito: `Module1` do objeto original e' compartilhado com o dado do
             * usuario guardado pelo AuthenticationService, e filtrar no lugar o corromperia.
             */
            function withRoutableItems(modules) {
                const hidden = [];

                const kept = modules
                    .map(module => {
                        const children = (module.Module1 || []).filter(child => {
                            if (stateOf(child))
                                return true;

                            hidden.push(`${module.Title} > ${child.Title} (${child.Url})`);

                            return false;
                        });

                        return angular.extend({}, module, { Module1: children });
                    })
                    .filter(module => {
                        if (module.Module1.length || stateOf(module))
                            return true;

                        hidden.push(`${module.Title} (${module.Url})`);

                        return false;
                    });

                if (hidden.length)
                    console.warn(`[menu] item sem rota neste front, escondido: ${hidden.join(', ')}`);

                return kept;
            }

            function compareMenuTitle(a, b) {
                if (a.Title < b.Title)
                    return -1;

                if (a.Title > b.Title)
                    return 1;

                return 0;
            }

            function setFirstRunCurrentModule() {
                let currentStateUrl = $state.current.url;

                if (currentStateUrl.split('/').length > 2) {
                    currentStateUrl = `/${currentStateUrl.split('/')[1]}`
                }

                let currentModule = vm.modules.find(mod => (currentStateUrl == mod.Url));

                if (!currentModule) {
                    vm.modules.forEach(mod => {
                        if (mod.Module1 && mod.Module1.length && mod.Module1.find(subMod => subMod.Url == currentStateUrl)) {
                            currentModule = mod;
                        }
                    })
                }

                if (currentModule)
                    currentModule.IsOpen = true;
            }

            function init() {
                vm.logout = AuthenticationService.logout;
                vm.loggedUserData = AuthenticationService.getUserData();
                vm.isMobile = $rootScope.isMobile;

                angular.element($window).on('resize', () => {
                    $rootScope.isMobile = HelperService.isScreenSmaller(767);

                    $timeout(() => {
                        vm.isMobile = $rootScope.isMobile;
                    });
                });

                const lsValue = localStorage.getItem(LOCAL_STORAGE_ITEMS.MENU);
                let isMenuOpen = true;

                if (lsValue == 'false' || lsValue == false || vm.isMobile)
                    isMenuOpen = false;

                $timeout(() => {
                    vm.menuOpen = isMenuOpen;
                    $rootScope.menuOpen = isMenuOpen;

                    $.fn.scrollbar && $('.scrollable').scrollbar({
                        ignoreOverlay: false
                    });

                    const modules = withRoutableItems(AuthenticationService.getModules()).sort(compareMenuTitle);

                    vm.modules = modules;

                    setFirstRunCurrentModule();
                })
            }
        }

        return {
            bindToController: true,
            controller: SidebarController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/sidebar/sidebar.html`,
            scope: {}
        }
    }
}());